import {Component} from '@angular/core';
import {NavParams, ViewController, Platform} from 'ionic-angular';

// pwa/app difference: App uses Ionic native social sharing

@Component({
  selector: 'page-achievement',
  templateUrl: 'achievement.html'
})
export class AchievementPage {
  achievement: any;

  constructor(private navParams: NavParams,
              private viewCtrl: ViewController,
              public platform: Platform,) {
    this.achievement = navParams.get('achievement')
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }

  onShare() {
    // should share on social media
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/my-classes/achievements/achievement/achievement.ts